import * as React from 'react'
import { connect } from 'react-redux'
// @ts-ignore
import { Button } from 'relevant-ui'
import { compose } from 'redux'
import '../style.scss'
import { withTranslation } from 'react-i18next'

interface Props {
  handleCancel: () => void
  handleConfirm: () => void
  t: any
  description: string
  warning: string
  title: string
  name: string
  submitting: any
  handleSubmit: any
  disable: boolean
}

const ModalConfirm = (props: Props) => {
  const {
    handleCancel,
    description,
    handleConfirm,
    warning,
    title,
    name,
    disable,
    t,
  } = props

  return (
    <div className="modalConfirm">
      <div className="icon" />
      <div className="title">{title}</div>
      <div className="description">
        {description || t('modal.description.default')}
        {name && <span>{name}</span>}
      </div>
      <div className="warning">{warning}</div>
      <div className="buttons mt-20">
        <Button
          className="button secondary large"
          label={t('cancel')}
          onClick={handleCancel}
          button="large"
        />
        <Button
          className="button primary large ml-20"
          type="submit"
          label={t('validate')}
          size="large"
          disabled={disable}
          onClick={handleConfirm}
          button="primary"
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state: any) => {
  const {
    modal: { disable },
  } = state

  return {
    disable,
  }
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps),
)(ModalConfirm)
